export class ModalNewsletterObserver {
    constructor() {

    }

    next(res) {
        document.querySelector('#newsletter-form-modal').reset();
        let btn = document.querySelector("#submit-modal-newsletter");
        btn.style.backgroundColor = "#45b254";
        btn.style.border = "solid 1px #45b254";
        btn.innerText = "OK";

        setTimeout(() => {
            document.body.classList.remove('block-scroll')
            document.querySelector('.modal-newsletter').classList.remove('modal--active')
        }, 1000);
        
    }

    error(error) {
        setTimeout(() => {
            document.body.classList.remove('block-scroll')
            document.querySelector('.modal-newsletter').classList.remove('modal--active')
        }, 1000);
        
    }

    complete() {}
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-newsletter/modal-newsletter.observer.js